import { Amplify } from 'aws-amplify'
import awsConfig from 'aws-exports'

const appHostname: string = import.meta.env.VITE_APP_HOSTNAME
const cognitoDomain: string = import.meta.env.VITE_COGNITO_DOMAIN
const redirectSignIn: string = `${appHostname}/sign-in/callback`
const redirectSignOut: string = `${appHostname}/sign-in`

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: awsConfig.aws_user_pools_id,
      userPoolClientId: awsConfig.aws_user_pools_web_client_id,
      identityPoolId: awsConfig.aws_cognito_identity_pool_id,
      loginWith: {
        oauth: {
          providers: [{ custom: 'Okta' }],
          domain: cognitoDomain,
          scopes: [
            'email',
            'profile',
            'openid',
            'aws.cognito.signin.user.admin',
          ],
          redirectSignIn: [redirectSignIn],
          redirectSignOut: [redirectSignOut],
          responseType: 'code',
        },
      },
    },
  },
})
